import { Component, OnInit, ViewEncapsulation, TemplateRef } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MainService } from '@root/main.service';
import { HttpClient } from '@angular/common/http';
import { Locale } from '@root/models/Locale';
import { Reservation } from '@root/models/Reservation';
import { Department } from '@root/models/Department';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {OrderModel} from '@root/models/OrderModel';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {TimeSlot} from '@root/models/TimeSlot';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import { WindowReferenceService } from '@root/window-reference.service';
import {TimeSlotResponse} from '@root/models/TimeSlotResponse';
import {Event} from '@root/models/Event';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReservationComponent implements OnInit {

  private window;
  reservationPaymentModalRef?: BsModalRef;
  privacyModalRef?: BsModalRef;
  marketingModalRef?: BsModalRef;
  minReservationDate: Date;
  maxReservationDate: Date;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private _http: MainService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private _localeService: BsLocaleService,
    private _windowRef: WindowReferenceService
  ) {
    translate.addLangs(['en', 'pl', 'ru', 'ua']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|pl|ru|ua/) ? browserLang : 'en');
    this.minReservationDate = new Date();
    this.minReservationDate.setDate(this.minReservationDate.getDate());
    this.maxReservationDate = new Date();

    if (browserLang === 'pl') {
      this._localeService.use('pl');
    } else {
      this._localeService.use('en');
    }

    this.window = _windowRef.nativeWindow;
  }

  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  phoneOrderForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  public locale_code;
  public parentOrigin;
  private userLanguage;
  public localeModel: Locale;
  public reservationModel: Reservation;
  public department: Department;
  next_step = false;
  step = 1;
  public personsList = null;
  public reservationSlotLimit = 0;
  public time_active = 0;
  public requestInProcess = false;
  privacyDeliveryHandlerOpenedStyle: string;
  privacyDeliveryButtonCloseStyle: string;
  termsHandlerOpenedStyle: string;
  termsButtonCloseStyle: string;
  reservationDaysDisabled: [0,6];
  reservationTimeSlots: TimeSlot[];
  reservationTimeSlotsMessageCode: number;
  public reservationPaymentInProgress = false;
  public reservationPaymentCompleted = false;
  public reservationPaymentCompletedStatus = 4;
  public localeEventData: Event = null;
  public eventDescriptionExpanded = false;
  public price_depends_on_persons = false;
  marketingHandlerOpenedStyle: string;
  marketingButtonCloseStyle: string;

  public selectedDate: Date;
  public selectedTime: string;
  public selectedPersons: number;
  public selectedDuration: number;
  public rwg_token: string;
  public reservation_id = false;
  public reservationModelErrors = {
    name: false,
    email: false,
    phone: false,
    checkbox_privacy: false,
    checkbox_terms: false,
    checkbox_agreement: false,
  };


  disabledDates = [

  ];
  public orderModel: OrderModel;
  public errorMsgShow: boolean;

  ngOnInit(): void {
    // Get locale code from URL
    this.userLanguage = navigator.language.split('-')[0];
    this.locale_code = location.search.split('cn=')[1];
    this.parentOrigin = new URLSearchParams(location.search).get('parentOrigin');

    let persons = location.search.split('persons=')[1];
    let slot = location.search.split('slot=')[1];
    let duration = location.search.split('duration=')[1];
    let hall = null;

    this.route.queryParams.subscribe(params => {
      this.locale_code = params['cn'];
      persons = params['persons'];
      slot = params['slot'];
      duration = params['duration'];
      hall = params['hall'];
      this.rwg_token = params['rwg_token'];
      this.reservation_id = params['reservation_id'];
    });

    if (this.reservation_id) {
      this._http.getReservation(this.reservation_id).subscribe(
        data => this.processReservation(data),
        error => console.log(error)
      );
    } else {
      let unix_timestamp = parseInt(slot);
      var date = new Date(unix_timestamp * 1000).toLocaleDateString('pl-PL', {
        timeZone: 'Europe/Warsaw'
      });
      this.selectedDate = new Date(unix_timestamp * 1000);
      this.selectedTime = new Date(unix_timestamp * 1000).toLocaleTimeString('pl-PL', {
        timeZone: 'Europe/Warsaw'
      });
      this.selectedPersons = parseInt(persons);
      this.selectedDuration = parseInt(duration);

      // console.log([this.locale_code, date, this.selectedTime, this.selectedDate, this.selectedPersons, this.selectedDuration, this.rwg_token]);
      this.reservationModel = new Reservation();
      this.reservationModel.phone = '';
      this.reservationModel.persons = this.selectedPersons;
      this.reservationModel.reservationData = this.selectedDate;
      this.reservationModel.department = null;
      this.reservationModel.language = this.userLanguage;
      this.reservationModel.rwg_token = this.rwg_token;
      this.reservationModel.is_google = true;
      this.reservationModel.preferred_hall_id = hall ? parseInt(hall) : 0;

      this.localeModel = new Locale();
      this.localeModel.menuToken = '';

      if (this.locale_code) {
        this._http.getLocale(this.locale_code, this.userLanguage).subscribe(
          data => this.localeModel = data,
          error => console.log(error),
          () => this.processLocale()
        );
      }
    }
  }

  /**
   * Get locale information
   */
  processLocale () {
    this.orderModel = new OrderModel();
    this.reservationModel.code = this.localeModel.code;
    this.personsList = this.localeModel.personsList;
      this.reservationModel.department = this.localeModel.departments[0];
      this.orderModel.department = this.localeModel.departments[0];
    this._http.getDepartment(this.reservationModel.department.id, 0).subscribe(
      data => this.department = data,
      error => console.log(error),
      () => this.processDepartment(),
    );
  }

  checkAvailableTimesTimes () {
    if (this.reservationModel.reservationData && this.reservationModel.persons) {
      this.next_step = false;
      this.time_active = -1;
      this.reservationModel.time = this.reservationModel.time ?? null;

      this._http.getTimeSlots(
        this.reservationModel.department.id,
        this.getHumanReservationDate(),
        this.reservationModel.persons,
        this.reservationModel.preferred_hall_id,
        this.reservationModel.duration_id
      ).subscribe(
        data => {
          this.selectTimeSlot(data);
        },
        error => console.log(error),
        () => {
          this.checkIfPaymentRequired();
        }
      );
    }
  }
  selectTimeSlot(timeSlotResponse: TimeSlotResponse) {
    this.reservationTimeSlots = timeSlotResponse.TimeSlot;
    this.reservationTimeSlotsMessageCode = timeSlotResponse.msg_code;

    if (this.selectedTime && !this.reservation_id) {
      this.reservationTimeSlots.forEach((timeSlot) => {
        // console.log([
        //   timeSlot.time, timeSlot.time + ':00',
        //   this.selectedTime,
        //   timeSlot.time + ':00' === this.selectedTime || timeSlot.time === this.selectedTime
        // ]);
        if (timeSlot.time + ':00' === this.selectedTime || timeSlot.time === this.selectedTime) {
          this.processTimeClick(timeSlot, this.reservationTimeSlots.indexOf(timeSlot));
          return false;
        }
      });
    } else {
      this.processTimeClick(this.reservationModel.time, 1);
    }

  }

  checkIfPaymentRequired () {
    const selectedTimeNormalized = this.selectedTime ? this.selectedTime.substring(0, 5) : null;
    this._http.getPaymentInfo(
      this.reservationModel.department.id,
      this.getHumanReservationDate(),
      this.reservationModel.persons,
      this.reservationModel.id,
      selectedTimeNormalized,
      this.reservationModel.preferred_hall_id || null
    ).subscribe(
      data => {
        // @ts-ignore
        if (data.value  > 0) {
          this.reservationModel.department.payment_required = true;
          // @ts-ignore
          this.reservationModel.department.payment_val = data.value;
        } else {
          this.reservationModel.department.payment_required = false;
          this.reservationModel.department.payment_val = 0;
        }
        this.price_depends_on_persons = data.depends_of_people.depends_of_people;
        if (this.price_depends_on_persons) {
          this.reservationModel.department.payment_total = this.reservationModel.department.payment_val;
          this.reservationModel.department.payment_val = data.depends_of_people.value;
        }

        // Find event matching reservation time and populate localeEventData
        if (data.events && data.events.length > 0 && this.selectedTime) {
          // Normalize selectedTime from "HH:MM:SS" to "HH:MM" to match event's start_time format
          const normalizedTime = this.selectedTime.substring(0, 5);
          const matchingEvent = data.events.find(e => e.start_time === normalizedTime);
          if (matchingEvent) {
            this.localeEventData = matchingEvent;
          }
        }
      },
      error => console.log(error),
      () => {console.log(this.reservationModel)}
    );
  }

  getEventDisplayPrice(): number {
    const event = this.localeEventData;
    if (event.min_people && event.min_people_price && this.reservationModel.persons >= event.min_people) {
      return event.min_people_price;
    }
    return event.price;
  }

  isEventPricePerPerson(): boolean {
    const event = this.localeEventData;
    if (event.min_people && event.min_people_price && this.reservationModel.persons >= event.min_people) {
      return !!event.min_people_depends_of_people;
    }
    return !!event.depends_of_people;
  }

  openLink(url, preOpenedWindow: Window | null = null) {
    this.reservationPaymentInProgress = true;
    if (url.isSubmitForm && url.isSubmitForm === true && url.form.length > 0) {
      if (preOpenedWindow) {
        preOpenedWindow.close();
      }
      if (window.self !== window.top) {
        let parentOrigin = document.referrer ? new URL(document.referrer).origin : '*';
        if (this.parentOrigin) {
          parentOrigin = decodeURIComponent(this.parentOrigin);
        }

        window.top.postMessage({ type: 'submitForm', formHtml: url.form }, parentOrigin);
      } else {
        this.submitHiddenForm(url.form);
      }
    } else {
      // Check if running inside an iframe - use postMessage to parent for Safari compatibility
      if (window.self !== window.top) {
        if (preOpenedWindow) {
          preOpenedWindow.close();
        }
        let parentOrigin = document.referrer ? new URL(document.referrer).origin : '*';
        if (this.parentOrigin) {
          parentOrigin = decodeURIComponent(this.parentOrigin);
        }
        window.top.postMessage({ type: 'openUrl', url: url }, parentOrigin);
      } else {
        if (preOpenedWindow) {
          preOpenedWindow.location.href = url;
          preOpenedWindow.focus();
        } else {
          const newWindow = window.open(url, '_blank');
          if (newWindow) {
            newWindow.focus();
          }
        }
      }
    }
    this.checkReservationStatus();
  }

  private submitHiddenForm(formHtml: string) {
    const container = document.createElement('div');
    container.style.display = 'none';
    container.innerHTML = formHtml;

    document.body.appendChild(container);

    const form = container.querySelector('form') as HTMLFormElement;
    if (form) {
      setTimeout(() => {
        form.submit();
        document.body.removeChild(container);
      }, 50);
    }
  }

  checkReservationStatus () {
    var self = this;
    console.log(self.reservationModel);
    var sub = window.setInterval(function(){
      self._http.getReservationStatus(self.reservationModel.code).subscribe(
        data => {
          if (data['status'] < 4) {
            clearInterval(sub);
          }
          if (data['status'] !== 4 && data['status'] !== self.reservationPaymentCompletedStatus) {
            self.reservationPaymentInProgress = false;
            self.reservationPaymentCompleted = true;
            self.reservationPaymentCompletedStatus = data['status'];
          }
        },
        error => self._showError(error),
        () => {  }
      );

    }, 5000);
  }

  /**
   * Process reservation
   */
  sendReservation() {
    if (this.requestInProcess) {
      return;
    }
    if (!this.validateForm()) {
      return;
    }
    this.requestInProcess = true;

    // Open window BEFORE HTTP request (Safari requires synchronous call from click handler)
    // Only open if NOT in iframe - in iframe we use postMessage to parent

    const isInIframe = window.self !== window.top;
    const newWindow = isInIframe ? null : window.open('about:blank', '_blank');

    if (this.reservationModel.id) {
      this._http.sendGetReservationPaymentLink(this.reservationModel).subscribe(
        data => {
          if (data['status'] === 500) {
            console.log('SERVER ERROR', data);
            this.toastr.error(
              this.translate.instant('BOOK.SERVER_ERROR'),
              '',
              {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            if (newWindow) { newWindow.close(); }
            return this.processError();
          } else if (data['status'] === 400) {
            // this.toastr.error(this.translate.instant('BOOK.WRONG_PHONE'),
            // '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.reservationModelErrors.phone = true;
            if (newWindow) { newWindow.close(); }
            return this.processError();
          } else {
            this.step = 3;
            this.requestInProcess = false;
            this.openLink(data.link, newWindow);
          }
        },
        error => {
          console.log('SERVER ERROR', error);
          this.toastr.error(
            this.translate.instant('BOOK.WRONG_RESERVATION'),
            '',
            {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          if (newWindow) { newWindow.close(); }
          return this.processError();
        },
        () => false
      );
    } else {
      this._http.sendReservation(this.reservationModel).subscribe(
        data => {
          if (data['status'] === 500) {
            console.log('SERVER ERROR', data);
            this.toastr.error(
              this.translate.instant('BOOK.SERVER_ERROR'),
              '',
              {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            if (newWindow) { newWindow.close(); }
            return this.processError();
          } else if (data['status'] === 400) {
            // this.toastr.error(this.translate.instant('BOOK.WRONG_PHONE'),
            // '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.reservationModelErrors.phone = true;
            if (newWindow) { newWindow.close(); }
            return this.processError();
          } else {
            this.processReservationResponse(data, newWindow);
          }
        },
        error => {
          console.log('SERVER ERROR', error);
          this.toastr.error(
            this.translate.instant('BOOK.WRONG_RESERVATION'),
            '',
            {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          if (newWindow) { newWindow.close(); }
          return this.processError();
        },
        () => false
      );
    }

  }
  validateForm() {
    let valid = true;
    if (!this.reservation_id) {
      if (!this.validateEmail(this.reservationModel.email)) {
        this.reservationModelErrors.email = true;
        valid = false;
      } else {
        this.reservationModelErrors.email = false;
      }
      if (!this.reservationModel.name) {
        this.reservationModelErrors.name = true;
        valid = false;
      } else {
        this.reservationModelErrors.name = false;
      }
      if (!this.reservationModel.phone || this.reservationModel.phone === '' || this.reservationModel.phone === undefined) {
        this.reservationModelErrors.phone = true;
        valid = false;
      } else {
        this.reservationModelErrors.phone = false;
      }
    }
    if (!this.reservationModel.checkbox_privacy) {
      this.reservationModelErrors.checkbox_privacy = true;
      valid = false;
    } else {
      this.reservationModelErrors.checkbox_privacy = false;
    }
    // if (!this.reservationModel.checkbox_terms) {
    //   this.reservationModelErrors.checkbox_terms = true;
    //   valid = false;
    // } else {
    //   this.reservationModelErrors.checkbox_terms = false;
    // }
    if (this.localeModel.reservations_payments_terms && this.localeModel.reservations_payments_terms_required > 0) {
      if (!this.reservationModel.agreement) {
        this.reservationModelErrors.checkbox_agreement = true;
        valid = false;
      } else {
        this.reservationModelErrors.checkbox_agreement = false;
      }
    }

    if (this.reservationModel.checkbox_terms) {
      this.reservationModel.marketing_consent = true;
    }
    return valid;
  }
  checkReservationModelErrors(field) {
    if (this.reservationModelErrors[field] === true && this.reservationModel[field] !== '') {
      this.reservationModelErrors[field] = false;
    }
  }

  processReservationResponse (data, preOpenedWindow: Window | null = null) {
    this.reservationModel.reservation_code = data.reservation_code;
    this.reservationModel.reservation_status = data.reservation_status;
    this.reservationModel.payment_url = data.payment_url;
    this.reservationModel.code = data.code;
    this.reservationModel.is_queued = data.is_queued || 0;
    if (data.payment_url) {
      this.reservationModel.department.payment_required = true;
    }
    this.step = 3;
    this.requestInProcess = false;
    this.openLink(data.payment_url, preOpenedWindow);

    // Fire reservation tracking script locally (for direct/non-iframe mode)
    if (typeof this.window.sendReservation !== 'undefined') {
      this.window.sendReservation(this.reservationModel.phone?.number, this.reservationModel.email);
    }

    // Notify parent window (for iframe mode)
    if (window.self !== window.top) {
      let parentOrigin = document.referrer ? new URL(document.referrer).origin : '*';
      if (this.parentOrigin) {
        parentOrigin = decodeURIComponent(this.parentOrigin);
      }
      window.top.postMessage({
        type: 'reservationCompleted',
        phone: this.reservationModel.phone?.number,
        email: this.reservationModel.email
      }, parentOrigin);
    }
  }

  processError() {
    this.step = 2;
    this.requestInProcess = false;
    this.reservationPaymentInProgress = false;
    return true;
  }

  processDepartment () {
    this.personsList = this.department.personsList;
    // this.aviable_reservations_list = this.department.reservationList;
    this.reservationSlotLimit = this.department.reservationSlotLimit;
    if (this.department.durationOptions[0]) {
      // @ts-ignore
      this.reservationModel.duration_id = this.department.durationOptions[0].id;
    } else {
      var selectedHours = this.selectedDuration / 60;
      var selectedMinutes = this.selectedDuration % 60;

      this.department.durationOptions.forEach((option) => {
       // if(option.hours == selectedHours && option.minutes == selectedMinutes) {
       //    this.reservationModel.duration_id = option.id;
       //  }
      }, this);
    }

    this.checkAvailableTimesTimes();

    if (this.department.maxDaysInReservationCalendar > 0) {
      this.maxReservationDate.setDate(this.maxReservationDate.getDate() + this.department.maxDaysInReservationCalendar);
    }


    return;
  }

  unsetDepartment () {
    this.department = null;
    this.personsList = 0;
    this.step = 1;
    this.next_step = false;
  }

  cleanReservation () {
    this.reservationModel = new Reservation();
    this.reservationModel.phone = '';
    this.reservationModel.persons = 0;
    this.reservationModel.reservationData = 0;
    this.reservationModel.department = null;
    this.reservationModel.language = this.userLanguage;

    this.processLocale();

    this.step = 1;
    this.personsList = 0;
    this.next_step = false;
  }

  validateEmail (email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  showPrivacy (template: TemplateRef<any>) {
    this.privacyModalRef = this.modalService.show(template);
  }

  showDeliveryPrivacy (show = true) {
    if (show) {
      this.privacyDeliveryHandlerOpenedStyle = 'handler-opened';
      this.privacyDeliveryButtonCloseStyle = 'make-close';
    } else {
      this.privacyDeliveryHandlerOpenedStyle = '';
      this.privacyDeliveryButtonCloseStyle = '';
    }
  }
  showDeliveryTerms (show = true) {
    if (show) {
      this.termsHandlerOpenedStyle = 'handler-opened';
      this.termsButtonCloseStyle = 'make-close';
    } else {
      this.termsHandlerOpenedStyle = '';
      this.termsButtonCloseStyle = '';
    }
  }
  showReservationPaymentRegulamin (template: TemplateRef<any>) {
    this.reservationPaymentModalRef = this.modalService.show(template);
  }

  showMarketing (template: TemplateRef<any>) {
    this.marketingModalRef = this.modalService.show(template);
  }

  setReservationDuration(option) {
    this.reservationModel.duration_id = option.id;
    this.checkAvailableTimesTimes();
  }
  processTimeClick (time, index) {
    // if (time.available) {
      this.time_active = 1;
      this.next_step = true;
      this.step = 2;
      if (!this.reservation_id) {
        // console.log('processTimeClick', time, index);
        const timeStr = typeof time === 'string' ? time : time.time;
        this.reservationModel.time = timeStr;
        this.selectedTime = timeStr;
        this.checkIfPaymentRequired();
      }
    // }
  }
  getTranslation (text) {
    return this.translate.instant(text);
  }

  _showError(error) {
    this.errorMsgShow = true;
  }
  getHumanReservationDate (withYear = true) {
    var result = '';
    if (this.reservationModel.reservationData) {
      let d = this.reservationModel.reservationData.getDate();
      let m = this.reservationModel.reservationData.getMonth() + 1; //Month from 0 to 11
      result = '' + (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m);
      if(withYear) {
        let y = this.reservationModel.reservationData.getFullYear();
        result += '.' + y;
      }
    }
    return result;
  }

  processReservation (data) {
    if (data.redirectLink) {
      this.openLink(data.redirectLink);
      return;
    }

    this.localeModel = data.locale;
    this.reservationModel = data.reservation;
    // this.processLocale();
    this.department = data.department;
    this.localeEventData = data.localeEvent || null;
    this.orderModel = new OrderModel();
    // this.reservationModel.code = this.localeModel.code;
    this.reservationModel.department = data.department;
    this._http.getDepartment(this.reservationModel.department.id, 0).subscribe(
      data => this.department = data,
      error => console.log(error),
      () => this.processDepartment(),
    );
    this.orderModel.department = data.department;
    this.reservationModel.reservationData = new Date(data.reservation.reservation_for_date_time);
    this.selectedTime = this.reservationModel.time;

    if (this.reservationModel.id) {
      this.phoneForm.get('phone').disable();
    }

    this.checkAvailableTimesTimes();
  }

}
